import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import { STAFF_ONLY, access } from '../../access';

const WorkspaceListPage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceListPage')
);
const WorkspaceCreatePage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceCreatePage')
);

// STAFF_ONLY mirrors the backend menu, which serves Workspace to internal viewers only and names no key:
// Workspace_View_R has no v2 equivalent. Old Workspace (/WorkspaceConfig*) stays retired, so it is not restored.
const workspaceRoutes = [
  {
    path: '/workspaceList',
    handle: createCrumbHandle('Workspaces'),
    children: [
      {
        index: true,
        element: <WorkspaceListPage />,
        handle: access(STAFF_ONLY),
      },
      {
        path: 'createWorkspace/:id',
        element: <WorkspaceCreatePage />,
        handle: { ...createCrumbHandle('Create Workspace'), ...access(STAFF_ONLY) },
      },
      {
        path: 'editWorkspace/:id',
        element: <WorkspaceCreatePage />,
        handle: { ...createCrumbHandle('Edit Workspace'), ...access(STAFF_ONLY) },
      },
    ],
  },
];

export default workspaceRoutes;
